/**
 * convert_bytes (conversion_helper.php, IEC 1024, '%01.2f %s')
 * si number_format(..., 0, ',', '.') din machetele ITIL / NIS2.
 */

export function convertBytes(bytes: number): string {
  const units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB']
  const mod = 1024
  const power = bytes > 0 ? Math.min(units.length - 1, Math.floor(Math.log(bytes) / Math.log(mod))) : 0
  return `${(bytes / Math.pow(mod, power)).toFixed(2)} ${units[power]}`
}

export function formatNumber(value: number | string | null | undefined): string {
  const n = Math.trunc(Number(value) || 0)
  return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, '.')
}

/** sparkline din overview/dashboard/index.php - SVG, nu AmCharts. */
export function sparkline(series: Array<{ total?: number }> | undefined, tone = 'red'): string {
  if (!series || series.length === 0) return ''
  const values = series.map((point) => Math.max(0, Number(point.total) || 0))
  const max = Math.max(1, ...values)
  const width = 100
  const step = values.length > 1 ? width / (values.length - 1) : width
  const points = values
    .map((value, index) => `${Math.round(index * step * 100) / 100},${Math.round((30 - (value / max) * 26) * 100) / 100}`)
    .join(' ')
  return `<svg class="itil-spark itil-spark-${tone}" viewBox="0 0 100 30" preserveAspectRatio="none"><polyline points="${points}"/></svg>`
}

export function scoreTone(score: number | null): 'grey' | 'green' | 'yellow' | 'red' {
  if (score === null) return 'grey'
  return score >= 90 ? 'green' : score >= 70 ? 'yellow' : 'red'
}

export function percent(part: number, whole: number): number | null {
  return whole > 0 ? Math.round((Math.max(0, Math.min(part, whole)) * 100) / whole) : null
}

/** date('d M Y', $ts) - luna scurta in engleza, ca PHP. */
export function phpDay(value: string, utc = false): string {
  if (!value) return ''
  const raw = utc && !/Z|[+-]\d\d/.test(value) ? value.replace(' ', 'T') + 'Z' : value
  const d = new Date(raw)
  if (Number.isNaN(d.getTime())) return ''
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
  const day = utc ? d.getUTCDate() : d.getDate()
  const month = utc ? d.getUTCMonth() : d.getMonth()
  const year = utc ? d.getUTCFullYear() : d.getFullYear()
  return `${String(day).padStart(2, '0')} ${months[month]} ${year}`
}

/**
 * date('d.m H:i', strtotime($x)) - ora ferestrei de mentenanta din tabloul
 * ITIL. Macheta veche o formata asa; rescrierea tiparea data SQL intreaga,
 * si "2026-03-14 22:00:00" intr-o coloana de tabel e zgomot, nu informatie.
 */
export function phpDayTime(value: string): string {
  if (!value) return ''
  const d = new Date(value.replace(' ', 'T'))
  if (Number.isNaN(d.getTime())) return value
  const pad = (n: number) => String(n).padStart(2, '0')
  return `${pad(d.getDate())}.${pad(d.getMonth() + 1)} ${pad(d.getHours())}:${pad(d.getMinutes())}`
}
